import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'
import Icon from '@mdi/react'
import styled from 'styled-components'

export const WLANListHeaderTitle = styled.div`
  flex: 1;
  color: ${theme.colors.otterWarmBlack};
  font-weight: 900;
  max-width: initial;
  word-break: word;
  @media ${theme.devices.tabletMid} {
    word-break: normal;
  }
`

export const WLANListLeftBlockPrimary = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 0px;
  width: 100%;

  @media ${theme.devices.tabletMid} {
    font-size: 10px;
    flex: 2;
  }
`

export const WLANListLeftBlockStatus = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0px;
  width: 50px;
`

export const WLANListLeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 0px;
  width: 100%;
  @media ${theme.devices.mobile} {
    display: none;
  }
  @media ${theme.devices.tabletMid} {
    font-size: 10px;
  }
`

export const WLANListBtn = styled(CommonLinkButton)`
  display: flex;
`

export const WLANListRightBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 20px;
  max-width: 20px;
  gap: 15px;
  flex: 1;

  @media ${theme.devices.tabletMid} {
    font-size: 10px;
  }
`

export const WLANListIcon = styled(Icon)<{ open?: boolean }>`
  transition: transform 0.3s ease;
  transform: ${({ open }) => (open ? 'rotate(-180deg)' : 'rotate(0)')};
`

export const WLANListHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 14px;

  @media ${theme.devices.tablet} {
    gap: 18px;

    ${WLANListLeftBlock} {
      align-items: center;
      flex-direction: row;
    }
  }
`
